import { render, staticRenderFns } from "./VariationVariant.vue?vue&type=template&id=ae384df6&"
import script from "./VariationVariant.vue?vue&type=script&lang=js&"
export * from "./VariationVariant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports